// extracted by mini-css-extract-plugin
module.exports = {"root":"StickyBox_root__2Z_8R","left":"StickyBox_left__lwQGQ","right":"StickyBox_right__3yZX5"};